<b-modal v-model="modal_requirement_SP01" size="lg" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>

  <!-- ヘッダ -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- ボディ -->
  <template v-slot:default>
    <div class="container-fluid" style="min-height: 120px; white-space: pre-wrap;">
      <div class="w-100">
        <div class="box-margin-right" style="font-weight: bold;" v-html="displayInfo">
        </div>
      </div>
    </div>
    <processing-view :processing="isLoading"></processing-view>
  </template>

  <!-- フッタ-->
  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="isLoading">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>